import { useLayoutEffect, useState, type RefObject } from 'react';

export const useElementWidth = (ref: RefObject<HTMLElement>): number => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return width;
};
